// Cloudflare D1 API service for web-admin
// Uses VITE_CF_ACCOUNT_ID, VITE_CF_API_TOKEN, VITE_CF_D1_DATABASE_ID from .env

const ACCOUNT_ID = import.meta.env.VITE_CF_ACCOUNT_ID || ''
const API_TOKEN = import.meta.env.VITE_CF_API_TOKEN || ''
const DATABASE_ID = import.meta.env.VITE_CF_D1_DATABASE_ID || ''

export async function d1Query<T = any>(sql: string, params: any[] = []): Promise<T[]> {
  const endpoint = import.meta.env.DEV
    ? `/cf-api/accounts/${ACCOUNT_ID}/d1/database/${DATABASE_ID}/query`
    : '/api/d1'

  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(API_TOKEN ? { Authorization: `Bearer ${API_TOKEN}` } : {})
    },
    body: JSON.stringify({ sql, params })
  })

  if (!res.ok) throw new Error(`D1 Error: ${res.status} ${res.statusText}`)

  const data = await res.json()
  if (data.success && data.result?.length > 0) {
    return (data.result[0].results ?? []) as T[]
  }
  return []
}

export async function d1Insert(table: string, record: Record<string, any>): Promise<void> {
  const keys = Object.keys(record).filter(k => record[k] !== undefined && record[k] !== '')
  const cols = keys.join(', ')
  const placeholders = keys.map(() => '?').join(', ')
  const values = keys.map(k => record[k])
  await d1Query(`INSERT INTO ${table} (${cols}) VALUES (${placeholders})`, values)
}

export async function d1Update(table: string, id: number, record: Record<string, any>): Promise<void> {
  const keys = Object.keys(record).filter(k => k !== 'id' && k !== 'created_at')
  const setClause = keys.map(k => `${k} = ?`).join(', ')
  const values = [...keys.map(k => record[k]), id]
  await d1Query(`UPDATE ${table} SET ${setClause} WHERE id = ?`, values)
}

export async function d1Delete(table: string, id: number): Promise<void> {
  await d1Query(`DELETE FROM ${table} WHERE id = ?`, [id])
}
